import { Component } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { FirebaseFunctionsService } from './services/firebase-functions.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'les-etoiles-browser';
  constructor(private auth: AngularFireAuth, private router: Router, private afs: FirebaseFunctionsService){
    this.auth.authState.subscribe( res => {
      if ( res && res.uid != null){
        sessionStorage.setItem('userId', res.uid);
        this.afs.getUtilisateur(res.uid).forEach( user => {
          sessionStorage.setItem('userType', user['typeUtilisateur']);
        });
      }else{
        sessionStorage.setItem('userId', null);
        sessionStorage.removeItem('userId');
        sessionStorage.setItem('userType', null);
        sessionStorage.removeItem('userType');
        this.router.navigateByUrl('se_connecter');
      }
    });
  }
  // tslint:disable-next-line:typedef
  afficherPage() {
    document.getElementById('loader-container').style.display = 'none';
    document.getElementById('content').style.display = 'block';
  }
  /** Afficher les messages(reusitte, avertissement ou erreur) partout dans l'app */
  showMessage(typeMsg: number, msg: string, duree: number): void{
    if (msg !== '' && (typeMsg > 0 && typeMsg < 4) && duree > 1000){
      const appMessage = document.createElement('div');
      if (typeMsg === 1){
        appMessage.classList.add('appMsg');
        appMessage.classList.add('appMsg_success');
      }else if (typeMsg === 2){
        appMessage.classList.add('appMsg');
        appMessage.classList.add('appMsg_avertissement');
      }else{
        appMessage.classList.add('appMsg');
        appMessage.classList.add('appMsg_error');
      }
      const pMsg = document.createElement('p');
      pMsg.innerHTML = msg;
      appMessage.appendChild(pMsg);
      document.body.appendChild(appMessage);
      setTimeout( () => {
        document.body.removeChild(appMessage);
      }, duree);
    }
  }
  // tslint:disable-next-line:typedef
  navigateTo(url: string){
    this.router.navigateByUrl(url);
  }
}
